<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G2Jj5o/tc-custom/9780226431765.jpg?1722573928464" alt="This image is the cover for the book Forms of Attention"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forms of Attention
      </h1>
      <p class="bookDescription body article font2">
        <p>Sir Frank Kermode, the British scholar, instructor, and author, was an inspired critic. <i>Forms of Attention</i> is based on a series of three lectures he gave on canon formation, or how we choose what art to value. The essay on Botticelli traces the artist’s sudden popularity in the nineteenth century for reasons that have more to do with poetry than painting. In the second essay, Kermode reads Hamlet from a very modern angle, offering a useful (and playful) perspective for a contemporary audience. The final essay is a defense of literary criticism as a process and conversation that, while often conflating knowledge with opinion, keeps us reading great art and working with—and for—literature. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank Kermode
      </h2>
      
      <p class="authorDescription body article"><B>Frank Kermode</B> (1919–2010) was a British literary critic who taught English literature at University College London, the University of Cambridge, Columbia University, and Harvard University. His criticism was regularly featured in the <I>London Review of Books</I> and the <I>New York Review of Books</I>, and he was the author of many books including <I>The Sense of an Ending</I>; <I>The Classic</I>; <I>The Genesis of Secrecy</I>; and, most recently, <I>Concerning E. M. Forster</I>. Kermode was knighted in 1991.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28b5370c